<template>
<v-card flat>
  <request-status :request="req" />
  <center v-if="req.loading" >
    <v-progress-circular color="amber" class="my-4" indeterminate size="72" />
  </center>
  <share-card v-if="link && relationshipId"
    :relationship-id="relationshipId"
    :links="links" />
</v-card>
</template>
<script>
import ShareCard from '@/components/cards/ShareCard.vue'
export default {
  name: 'ShareAppointment',
  components: { ShareCard },
  props: {
    appointmentId: { required: true }
  },
  data () {
    return {
      req: {
        resource: 'ag.appointments'
      }
    }
  },
  watch: {
    appointmentId: {
      immediate: true,
      handler () {
        if (this.appointmentId) {
          this.get()
        }
      }
    }
  },
  computed: {
    appointment () {
      return this.getObjectPath(this.req, 'result', {})
    },
    relationshipId () {
      return this.getObjectPath(this.appointment, 'computed_relationship_id')
    },
    link () {
      if (this.appointment && this.appointment.id) {
        return this.getAppointmentShareLink(this.appointment)
      }
      return null
    },
    links () {
      if (this.link) { return [this.link] }
      return []
    }
  },
  methods: {
    get () {
      this.req.resourceId = this.appointmentId
      this.$request('get', this.req)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ShareAppointment.vue?4e6268d0